/*
 *
 *  * Copyright(c) 2022 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */

import { Pipe, PipeTransform } from '@angular/core';

export interface FilterTagContainerStylePipeData {
  isMultiLine: boolean;
  isCollapsed: boolean;
  lineHeight: number;
}

@Pipe({
  name: 'filterTagContainerStyle'
})
export class FilterTagContainerStylePipe implements PipeTransform {
  transform(data: FilterTagContainerStylePipeData): any {
    if (data.isMultiLine && data.isCollapsed) {
      return {
        'max-height': `${data.lineHeight}px`,
        overflow: 'hidden'
      };
    } else {
      return undefined;
    }
  }
}
